import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaFileAlt, FaUserPlus, FaHotel, FaCalendarAlt, FaHandshake, FaImages, FaEnvelope, FaPlane } from 'react-icons/fa';
import { MdGroups, MdRecordVoiceOver } from 'react-icons/md';
import { AiFillHome } from 'react-icons/ai';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };
  const closeMenu = () => {
    setIsOpen(false);
  };

  const isActive = (path) => location.pathname === path ? 'active' : '';

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-title" onClick={closeMenu}>
          NCAMST 2026
        </Link>

        {/* Hamburger */}
        <div className={`hamburger ${isOpen ? 'active' : ''}`} onClick={toggleMenu}>
          <span className="bar"></span>
          <span className="bar"></span>
          <span className="bar"></span>
        </div>

        {/* Nav Items */}
        <ul className={`navbar-items ${isOpen ? 'open' : ''}`}>
          <li><Link to="/" className={`nav-link ${isActive('/')}`} onClick={closeMenu}><AiFillHome /> Home</Link></li>
          <li><Link to="/committees" className={`nav-link ${isActive('/committees')}`} onClick={closeMenu}><MdGroups /> Committees</Link></li>
          <li><Link to="/speakers" className={`nav-link ${isActive('/speakers')}`} onClick={closeMenu}><MdRecordVoiceOver /> Speakers</Link></li>
          <li><Link to="/abstract-submission" className={`nav-link ${isActive('/abstract-submission')}`} onClick={closeMenu}><FaFileAlt /> Submission</Link></li>
          <li><Link to="/fee-structure" className={`nav-link ${isActive('/fee-structure')}`} onClick={closeMenu}><FaUserPlus /> Registration</Link></li>
          <li><Link to="/accommodation" className={`nav-link ${isActive('/accommodation')}`} onClick={closeMenu}><FaHotel /> Accommodation</Link></li>
          <li><Link to="/travel" className={`nav-link ${isActive('/travel')}`} onClick={closeMenu}><FaPlane /> Travel</Link></li>
          <li><Link to="/brochure" className={`nav-link ${isActive('/brochure')}`} onClick={closeMenu}><FaCalendarAlt /> Schedule</Link></li>
          <li><Link to="/sponsorship" className={`nav-link ${isActive('/sponsorship')}`} onClick={closeMenu}><FaHandshake /> Sponsorship</Link></li>
          <li><Link to="/gallery" className={`nav-link ${isActive('/gallery')}`} onClick={closeMenu}><FaImages /> Gallery</Link></li>
          <li><Link to="/contact" className={`nav-link ${isActive('/contact')}`} onClick={closeMenu}><FaEnvelope /> Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;  